module.exports = __webpack_public_path__ + "static/media/Harshwardhan Deshmukh.9a14b821.jpg";